import { totalCommentsConfig } from '@/lib/analytics/kpis/youtube/totalComments';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerCommentsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...totalCommentsConfig,
    size: SIZE_50,
    name: 'kpi.youtube.mediaviewer.comments',
    tooltip: null,
    loader: MediaViewerKpiLoader,
    mergedData: true
};
